
import React, { useEffect, useState } from "react";
import {
   Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
   Paper, Grid, Typography, Checkbox, Box,
   tabClasses
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SearchBar from "../../../Common/UtilityCommon/SearchBar";
import PerPageSelect from "../../../Common/UtilityCommon/PerPageSelect";
import Pagination from "../../../Common/UtilityCommon/Pagination";
import CircularSpinner from "../../../Common/Spinners/CircularSpinner";
import axios from "axios";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import Swal from "sweetalert2";


var CustomerName = "";

const styles = {
   tableHeaderCell: {
      fontSize: "16px",
      fontWeight: "bold",
      backgroundColor: "#f4f4f4",
      whiteSpace: "nowrap",
      position: "sticky",
      top: 0,
      zIndex: 1,
   },
};

//API URL
const API_URL = process.env.REACT_APP_API;

const AuctionEntryUtility = ({ includeYearCode = true,
   rowKey = "AwakDetailId",
}) => {

   const [rows, setRows] = useState([]);
   const [filteredRows, setFilteredRows] = useState([]);
   const [loading, setLoading] = useState(true);
   const [filteredData, setFilteredData] = useState([]);
   const [searchTerm, setSearchTerm] = useState("");
   const [perPage, setPerPage] = useState(15);
   const [currentPage, setCurrentPage] = useState(1);
   const [selectedRows, setSelectedRows] = useState({});
   const [CustomerCode, setCustomerCode] = useState("");


   const [formDataDetail, setFormDataDetail] = useState({
      Customer_Code: 0,
      cc: 0,
   });

   const isUpdateEnabled = React.useMemo(() => {
      if (rows.length === 0) return false;

      return rows.every(row =>
         row.Customer_Code &&
         row.Customer_Code !== 0 &&
         row.Salerate &&
         Number(row.Salerate) > 0
      );
   }, [rows]);


   const navigate = useNavigate();
   const location = useLocation();
   const searchParams = new URLSearchParams(location.search);
   const navigatedRecord = searchParams.get('navigatedRecord');

   const paginatedPosts = filteredRows.slice((currentPage - 1) * perPage, currentPage * perPage);

   const apiUrl = `${process.env.REACT_APP_API}/getdata-ListForAuction`;

   const columns = [
      { label: "SR No", key: "SrNo" },
      { label: "ID", key: "AwakDetailId" },
      { label: "Awak No", key: "Doc_No" },
      { label: "Awak Date", key: "Doc_Date" },
      { label: "Farmer Code", key: "Ac_code" },
      { label: "Farmer Name", key: "Ac_Name_E" },
      { label: "Farmer Mobile No", key: "FarmerMobile" },
      { label: "Awak Qty", key: "Awak_Qty" },
      { label: "Item", key: "Item" },
      { label: "Godown", key: "Godown" },
      { label: "Line", key: "Line" },
      { label: "Customer Code", key: "Customer_Code" },
      { label: "Customer Mobile No", key: "CustomerMobile" },
      { label: "Sale Rate", key: "Salerate" },
   ];


   useEffect(() => {
      loadData();
   }, []);

   const loadData = async () => {
      try {
         setLoading(true);

         const Company_Code = sessionStorage.getItem("Company_Code");
         const Year_Code = sessionStorage.getItem("Year_Code");

         const finalUrl = `${apiUrl}?Company_Code=${Company_Code}${includeYearCode ? `&Year_Code=${Year_Code}` : ""
            }`;

         const res = await axios.get(finalUrl);
         const data = res.data.all_data || [];

         const sorted = [...data].sort((a, b) => {
            const aIncomplete =
               !a.Customer_Code || Number(a.Salerate || 0) <= 0;

            const bIncomplete =
               !b.Customer_Code || Number(b.Salerate || 0) <= 0;

            // Incomplete rows should appear on top
            if (aIncomplete && !bIncomplete) return -1;
            if (!aIncomplete && bIncomplete) return 1;

            // otherwise keep normal ordering
            return 0;
         });

         setRows(sorted);
         setFilteredRows(sorted);
      } catch (err) {
         console.error("Error fetching:", err);
      } finally {
         setLoading(false);
      }
   };


   const handleRowToggle = (rowId) => {
      setSelectedRows((prev) => ({
         ...prev,
         [rowId]: !prev[rowId]   // toggle
      }));
   };

   const handlecustomer = async (code, accoid) => {
      setCustomerCode(code);
      let updatedFormDataDetail = {
         ...formDataDetail,
         Customer_Code: code,
         cc: accoid,
      };
      setFormDataDetail(updatedFormDataDetail);
   };


   // ============================
   // FILTER
   // ============================
   // useEffect(() => {
   //    const term = searchTerm.toLowerCase();

   //    const filtered = rows.filter((row) =>
   //       Object.values(row).some((val) =>
   //          String(val).toLowerCase().includes(term)
   //       )
   //    );

   //    setFilteredRows(filtered);
   //    // setCurrentPage(1);
   // }, [searchTerm, rows]);

   useEffect(() => {
      const filtered = rows.filter(row =>
         String(row.Doc_No || "").startsWith(searchTerm)
      );

      setFilteredRows(filtered);
      // setCurrentPage(1);
   }, [searchTerm, rows]);


   const pageCount = Math.ceil(filteredRows.length / perPage);
   const paginatedRows = filteredRows.slice(
      (currentPage - 1) * perPage,
      currentPage * perPage
   );

   useEffect(() => {
      setCurrentPage(1);
   }, [searchTerm]);



   const handleCarryToAuction = async () => {
      debugger

      // const invalidRows = rows.filter(row => !row.Customer_Code || !row.Salerate);

      // if (invalidRows.length > 0) {
      //    Swal.fire({
      //       title: "Validation Error",
      //       text: "Customer Code and Sale Rate are required for all rows!",
      //       icon: "warning"
      //    });
      //    return; // stop execution
      // }


      const detailData = rows.map((row) => ({
         Id: row.AwakDetailId,
         AuctionMark: "Y",
         AuctionDate: row.AuctionDate || null,
         Customer_Code: row.Customer_Code || null,
         cc: row.cc || null,
         oldCustomerCode: row.Customer_Code,
         oldcc: row.cc,
         oldsalerate: row.Salerate || row.oldsalerate || null,
         Salerate: row.Salerate || null,
         rowaction: "update"
      }));
      console.log("detailData to send", detailData);


      try {

         await axios.put(`${API_URL}/Update_DetailForReadyForSaleAwakEntry`, { detailData });

         Swal.fire({
            title: "Success!",
            text: "Updated successfully!",
            icon: "success"
         });

         setTimeout(() => {
            window.onbeforeunload = null;
            window.location.reload();
         }, 800);

      } catch (err) {
         console.error(err);
         alert("Saving failed");
      }



      try {
         await axios.put(`${API_URL}/Update_DetailForReadyForSaleAwakEntry`, { detailData });

         Swal.fire({
            title: "Success!",
            text: "Updated successfully!",
            icon: "success"
         });

         setTimeout(() => {
            window.onbeforeunload = null;
            window.location.reload();
         }, 800);

      } catch (err) {
         console.error(err);
         alert("Saving failed");
      }
   };





   return (
      <>
         {/* ==================== HEADER SECTION ===================== */}
         <Grid container spacing={2} alignItems="center">
            <Grid item>
               <PerPageSelect value={perPage} onChange={(e) => {
                  setPerPage(e.target.value);
                  setCurrentPage(1);
               }} />
            </Grid>

            <Grid item xs display="flex" justifyContent="center">
               <Typography
                  variant="h6"
                  sx={{
                     textAlign: 'center',
                     fontSize: '1.2rem',
                     fontWeight: 'bold',
                     color: '#2c3e50',
                     ml: 62,
                     marginBottom: '10px',
                     padding: '12px 0',
                     position: 'relative',
                     '&::after': {
                        content: '""',
                        position: 'absolute',
                        bottom: '0',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        width: '80px',
                        height: '4px',
                        background: 'linear-gradient(90deg, #3498db, #2ecc71)',
                        borderRadius: '2px',
                        animation: 'underlineGrow 0.5s ease-out forwards'
                     },
                     '@keyframes underlineGrow': {
                        '0%': { width: '0' },
                        '100%': { width: '80px' }
                     }
                  }}
               >
                  Auction List
               </Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
               <SearchBar value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
            </Grid>
         </Grid>

         {/* ==================== TABLE ===================== */}
         <Paper sx={{ mt: 2 }}>
            <TableContainer sx={{ maxHeight: "70vh" }}>
               <Table stickyHeader>
                  <TableHead>
                     <TableRow
                        sx={{
                           height: 32,        // Header row height
                        }}
                     >
                        {columns.map((column, index) => (
                           <TableCell
                              key={index}
                              sx={{
                                 ...styles.tableHeaderCell,
                                 textAlign: column.format ? "right" : "left",
                                 padding: "4px 6px",
                                 fontSize: "14px",
                                 height: "32px",
                              }}
                           >
                              {column.label}
                           </TableCell>
                        ))}



                     </TableRow>
                  </TableHead>

                  <TableBody>
                     {loading ? (
                        <TableRow>
                           <TableCell colSpan={columns.length} align="center">
                              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 400 }}>
                                 <CircularSpinner />
                              </Box>
                           </TableCell>
                        </TableRow>
                     ) : paginatedPosts.length === 0 ? (
                        <TableRow>
                           <TableCell colSpan={columns.length} align="center" style={{ fontSize: "16px", fontWeight: "bold" }}>
                              No data found...
                           </TableCell>

                        </TableRow>
                     ) : (
                        paginatedPosts.map((post) => (
                           <TableRow
                              key={post[rowKey]}

                              // onDoubleClick={() => handleRowToggle(post[rowKey])}
                              sx={{
                                 cursor: "pointer",
                                 transition: "background-color 0.3s ease",
                                 "&:hover": {
                                    backgroundColor: "#f3f388",
                                 },
                                 height: 28,       // Row height (reduced)
                              }}
                           >
                              {columns.map((column, colIndex) => {
                                 const editableColumns = ["Customer_Code", "Salerate"];
                                 const isEditable = editableColumns.includes(column.key);

                                 return (
                                    <TableCell
                                       key={colIndex}
                                       sx={{
                                          whiteSpace: "nowrap",
                                          textAlign: column.format ? "right" : "left",
                                          padding: "2px 3px",
                                          fontSize: "13px",
                                          height: "28px",
                                       }}
                                    >
                                       {isEditable ? (

                                          column.key === "Customer_Code" ? (
                                             <AccountMasterHelp
                                                onAcCodeClick={(
                                                   Ac_Code,
                                                   accoid,
                                                   Ac_Name_E
                                                ) => {
                                                   const updatedRows = [...rows];
                                                   const index = rows.findIndex(r => r[rowKey] === post[rowKey]);
                                                   console.log("ROW CUSTOMER_CODE:", post.Customer_Code);

                                                   if (index !== -1) {
                                                      updatedRows[index]["Customer_Code"] = Ac_Code;
                                                      updatedRows[index]["cc"] = accoid;
                                                      updatedRows[index]["CustomerName"] = Ac_Name_E;
                                                      setRows(updatedRows);
                                                   }
                                                }}
                                                CategoryName={post["CustomerName"] || ""}
                                                CategoryCode={post["Customer_Code"] || ""}

                                                name="Customer_Code"
                                                Ac_type={[]}
                                                disabledFeild={false}
                                             />


                                          ) : (
                                             <input
                                                type="number"
                                                value={post[column.key] || ""}
                                                style={{ width: "100%", fontSize: "13px" }}
                                                onChange={(e) => {
                                                   const value = e.target.value;
                                                   const updatedRows = [...rows];
                                                   const index = rows.findIndex(r => r[rowKey] === post[rowKey]);
                                                   if (index !== -1) {
                                                      updatedRows[index][column.key] = value;
                                                      setRows(updatedRows);
                                                   }
                                                }}
                                             />
                                          )
                                       ) : (
                                          post[column.key]
                                       )}
                                    </TableCell>
                                 );
                              })}

                           </TableRow>
                        ))
                     )}
                  </TableBody>
               </Table>


            </TableContainer>
         </Paper>

         <Box mt={2} display="flex" justifyContent="center">
            <button
               onClick={handleCarryToAuction}
               // disabled={!isUpdateEnabled}
               style={{
                  padding: "10px 25px",
                  backgroundColor: "#3498db",
                  color: "white",
                  fontSize: "16px",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer"
               }}
            >
               Update
            </button>
         </Box>


         {/* ==================== PAGINATION ===================== */}
         <Box mt={3} mb={5}>
            <Pagination
               pageCount={pageCount}
               currentPage={currentPage}
               onPageChange={(page) => setCurrentPage(page)}
            />
         </Box>
      </>
   );
};

export default AuctionEntryUtility;
